// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"10328":"e0fc8b2420f8d3c0","46252":"d113263730c12970","52433":"40654dc18611525a","55422":"a7111f45d08d7be4"}[chunkId] + ".css";
};